/* eslint-disable import/no-anonymous-default-export */
import React from 'react';

import { PensionPolicyContext } from './PensionPolicyContext';

export default () => React.useContext(PensionPolicyContext);
